import React from "react";
import { Table, Placeholder } from "react-bootstrap";

const SkeletonTable: React.FC<{ rows?: number; columns?: number }> = ({
    rows = 5,
    columns = 10,
}) => {
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    {Array.from({ length: columns }).map((_, index) => (
                        <th key={index}>
                            <Placeholder animation="wave">
                                <Placeholder xs={6} />
                            </Placeholder>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {Array.from({ length: rows }).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                        {Array.from({ length: columns }).map((_, colIndex) => (
                            <td key={colIndex}>
                                <Placeholder animation="glow">
                                    <Placeholder xs={8} />
                                </Placeholder>
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default SkeletonTable;
